import { ActionTypes } from "../../reducers/dispenserUser/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import { PROYECT, api_get, api_post } from "../../../services/api";

const {
  OPEN_DISPENSER_USER_SNACK,
  CLOSE_DISPENSER_USER_SNACK,
  CREATE_DISPENSER_USER,
  CLEAR_DISPENSER_USER,
  GET_DRIVER_USER,
  GET_DISPENSER_USER,
  SET_DISPENSER_USER_FILTERS,
  DISPENSER_USER_SELECTED,
  RESET_DISPENSER_USER_SELECTED,
  
  SET_CONFIG_PAGE_DISPENSER_USER,
  SET_CONFIG_PAGE_SIZE_DISPENSER_USER,
  SET_CONFIG_FILTER_DISPENSER_USER,
  SET_CONFIG_SORTED_DISPENSER_USER
} = ActionTypes;

export const getDispenserUser = (unit = {}) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/dispensers/users/by_unit/${unit?.id}`;
  return async (dispatch) => {
    dispatch(startRequestComp('loadingDispenserUser'));
    await api_get(url).then(resp => {
      if (resp.length === 0) dispatch(setSnackbar('No se encontraron dispensadores'));
      dispatch({
        type: GET_DISPENSER_USER,
        payload: resp.map(dispenser => {
          let dispenserUser = dispenser.dispenserUser;
          if(!dispenserUser) dispenserUser = {
              username: 'SIN ASIGNAR',
              imei: 'SIN ASIGNAR'
            };
          else if(!dispenserUser?.imei) dispenserUser = {
              ...dispenserUser,
              imei: 'SIN ASIGNAR'
            };
          return {
            ...dispenser,
            dispenserUser
          };
        })
      });
    }).catch(error => dispatch(setSnackbar(error ? error : "Error contacte al administrador")));
    dispatch(stopRequestComp('loadingDispenserUser'));
  }
};

export const getDriverUser = (unit = {}) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/drivers/users/by_unit/${unit?.id}`;
  return async (dispatch) => {
    dispatch(startRequestComp('loadingDriverUser'));
    await api_get(url).then(resp => {
      if (resp.length === 0) dispatch(setSnackbar('No se encontro el usuario de la unidad'));
      else dispatch(getDispenserUser(unit));
      dispatch({
        type: GET_DRIVER_USER,
        payload: {
          ...resp,
          search: true
        }
      });
    }).catch(error => dispatch(setSnackbar(error ? error : "Error contacte al administrador")));
    dispatch(stopRequestComp('loadingDriverUser'));
  }
};

export const createNewDispenserUser = (form) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/dispensers/user`;
  return async ( dispatch ) => {
    dispatch(startRequestComp('loadingDispenserUser'));
    await api_post(url, form).then(resp => {
      dispatch({
        type: CREATE_DISPENSER_USER,
        payload: resp
      });
      dispatch(setSnackbar('El usuario se ha guardardo con éxito', 'success'));
    }).catch(error => {
      return dispatch(setSnackbar(error ? error : "Error contacte al administrador"));
    });
    dispatch(stopRequestComp('loadingDispenserUser'));
  }
};

export const setDispenserUserSnackBar = (msg) => ({
  type: OPEN_DISPENSER_USER_SNACK,
  payload: msg
});

export const closeDispenserUserSnackBar = () => ({
  type: CLOSE_DISPENSER_USER_SNACK,
});

export const dispenserUserSelected = (id) => ({
  type: DISPENSER_USER_SELECTED,
  payload: id
});

export const resetDispenserUserSelected = () => ({
  type: RESET_DISPENSER_USER_SELECTED
});

export const setDispenserUserFilters = (key = "", data) => ({
  type: SET_DISPENSER_USER_FILTERS,
  payload: { data, key }
});

export const clearDispenserUser = () => ({
  type: CLEAR_DISPENSER_USER,
});

export const setConfigPageDispenserUser = (page) => ({
  type: SET_CONFIG_PAGE_DISPENSER_USER,
  payload: page,
});

export const setConfigPageSizeDispenserUser = (pageSize) => ({
  type: SET_CONFIG_PAGE_SIZE_DISPENSER_USER,
  payload: pageSize,
});

export const setConfigFilteredDispenserUser = (filter) => ({
  type: SET_CONFIG_FILTER_DISPENSER_USER,
  payload: filter,
});

export const setConfigSortedDispenserUser = (sort) => ({
  type: SET_CONFIG_SORTED_DISPENSER_USER,
  payload: sort,
});